/*
 * Copyright (C) 2025 Hendrik. All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 * Written by Hendrik, December 28, 2025.
 */

import React, { useState, useEffect } from 'react';
import Navbar from "./navbar.jsx";
import ResourceBank from './components/ResourceBank.jsx';
import Dashboard from './dashboard.jsx';
import Recent from './recents.jsx';
import Subjects from './subjects.jsx';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import Mainsubjects from './mainsubjects.jsx';
import Subjectdetail from './subjectdetail.jsx';
import AllStudents from './allstudents.jsx';
import Login from './Login.jsx';
import UserManagement from './UserManagement.jsx';
import SchoolManagement from './SchoolManagement.jsx';
import HODDashboard from './HODDashboard.jsx';
import DeveloperDashboard from './DeveloperDashboard.jsx';
import PublicSubscription from './PublicSubscription.jsx';
import PrivacyPolicy from './PrivacyPolicy.jsx';
import Settings from './Settings.jsx';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is already logged in
    const authStatus = localStorage.getItem('isAuthenticated');
    if (authStatus === 'true') {
      setIsAuthenticated(true);
    }
    setLoading(false);
  }, []);

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('username');
    localStorage.removeItem('is_admin');
    localStorage.removeItem('is_hod');
    localStorage.removeItem('user_role');
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user_id');
    setIsAuthenticated(false);
  };

  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>Loading...</div>;
  }

  if (!isAuthenticated) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/subscription" element={<PublicSubscription />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="*" element={<Login onLoginSuccess={handleLoginSuccess} />} />
        </Routes>
      </BrowserRouter>
    );
  }

  // Check if user is HOD
  const isHOD = localStorage.getItem('is_hod') === 'true';
  const isDeveloper = localStorage.getItem('user_role') === 'developer';

  // If HOD, show only analytics dashboard
  if (isHOD) {
    return (
      <BrowserRouter>
        <Navbar onLogout={handleLogout} />
        <Routes>
          <Route path='/' element={<HODDashboard />} />
          <Route path='/analytics' element={<HODDashboard />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    );
  }

  // If Developer, show only developer dashboard
  if (isDeveloper) {
    return (
      <BrowserRouter>
        <Navbar onLogout={handleLogout} />
        <Routes>
          <Route path='/' element={<DeveloperDashboard />} />
          <Route path='/developer' element={<DeveloperDashboard />} />
          <Route path='/schools' element={<SchoolManagement />} />
          <Route path='/resources' element={<ResourceBank />} />
          <Route path="*" element={<Navigate to="/developer" replace />} />
        </Routes>
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter>
      <Navbar onLogout={handleLogout} />
      <Routes>
        <Route path='/' element={<div className="app-container">
          <Dashboard total_students={20} />
          <Recent />
          <Subjects />
        </div>}></Route>

        <Route path='/dashboard' element={<div className="app-container">
          <Dashboard total_students={20} />
          <Recent />
          <Subjects />
        </div>}></Route>

        <Route path='/subjects' element={<Mainsubjects />}></Route>

        <Route path='/subjects/:id' element={<Subjectdetail />}></Route>

        <Route path='/students' element={<AllStudents />}></Route>

        <Route path='/users' element={
          localStorage.getItem('is_admin') === 'true'
            ? <UserManagement />
            : <Navigate to="/dashboard" replace />
        }></Route>

        <Route path='/schools' element={
          localStorage.getItem('user_role') === 'developer'
            ? <SchoolManagement />
            : <Navigate to="/dashboard" replace />
        }></Route>

        <Route path="/settings" element={<Settings />} />
        <Route path="/resources" element={<ResourceBank />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
